module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad1/img_achievement03-8aeb8deae62980455161edf9280efe11.jpg";